import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import React from "react";
import { ColumnProps } from "types/models";
import { DataFormField } from "types/models/input-field-type";
import { convertDateStringToDateTimezone_7Dayjs } from "helper/common";
const { SELECT, DATE, COMBO_BOX } = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 };
const wrapperCol = { xs: 14, md: 16, xl: 12, lg: 16 };
const labelCol = { xs: 10, md: 12, xl: 12, lg: 8 };
const field: DataFormField[] = [
  {
    type: SELECT,
    label: "Khoa",
    name: "khoa",
    options: [{ value: 1, label: "Khoa mắt tổng hợp" }],
    rules: [{ message: "Chọn khoa là bắt buộc", required: true }],
  },
  {
    type: DATE,
    label: "Từ ngày",
    name: "start",
  },
  {
    type: DATE,
    label: "Đến ngày",
    name: "end",
  },
];
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2010;
const endYear = currentYear + 90;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const fieldQuyetToan: DataFormField[] = [
  {
    type: SELECT,
    label: "Tháng quyết toán",
    name: "thangQT",
    options: listMonths,
    css: css,
    wrapperCol,
    labelCol,
  },
  {
    type: COMBO_BOX,
    label: "Năm quyết toán",
    name: "namQT",
    options: listYears,
    css: css,
    wrapperCol,
    labelCol,
  },
];

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    isResizable: true,
    dataIndex: "stt",
    key: "stt",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    width: "3%",
    align: "center",
    // fixed: "left"
  },
  {
    title: "Mã PK",
    isResizable: true,
    dataIndex: "maPhieuKham",
    key: "maPhieuKham",
    show: true,
    align: "center",
  },
  {
    title: "Mã BN",
    isResizable: true,
    dataIndex: "maBenhNhan",
    key: "maBenhNhan",
    show: true,
    align: "center",
  },
  {
    title: "Họ tên",
    isResizable: true,
    dataIndex: "hoTen",
    key: "hoTen",
    show: true,
    align: "left",
  },
  {
    title: "Giới tính",
    isResizable: true,
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    show: true,
    align: "center",
    render: (v) => {
      return v === 0 ? "Nam" : "Nữ";
    },
  },
  {
    title: "Ngày sinh",
    isResizable: true,
    dataIndex: "ngaySinh",
    key: "ngaySinh",
    show: true,
    align: "center",
  },
  {
    title: "Địa chỉ",
    isResizable: true,
    dataIndex: "diaChi",
    key: "diaChi",
    show: true,
    align: "left",
  },
  {
    title: "Ngày xuất viện",
    isResizable: true,
    dataIndex: "ngayXuatVien",
    key: "ngayXuatVien",
    show: true,
    align: "center",
    render: (v) =>
      convertDateStringToDateTimezone_7Dayjs(v, FORMAT_TIME.dayFull),
  },
  {
    title: "Số thẻ BHYT",
    isResizable: true,
    dataIndex: "soTheBHYT",
    key: "soTheBHYT",
    show: true,
    align: "left",
  },
  {
    title: "Giá trị thẻ",
    isResizable: true,
    dataIndex: "giaTriThe",
    key: "giaTriThe",
    show: true,
    align: "left",
  },
  {
    title: "Mức hưởng",
    isResizable: true,
    dataIndex: "mucHuong",
    key: "mucHuong",
    show: true,
    align: "right",
  },
  {
    title: "Thao tác",
    isResizable: true,
    dataIndex: "action",
    key: "action",
    show: true,
    align: "center",
  },
];

export { field, allColumns, fieldQuyetToan };
